import { render, staticRenderFns } from "./SalesOrderDetails.vue?vue&type=template&id=5b6e902c&"
import script from "./SalesOrderDetails.vue?vue&type=script&lang=js&"
export * from "./SalesOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports